// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

:root {
  color-scheme: dark;
}

#root,
html,
body,
.nav-content {
  height: 100%;
}

#root {
  display: flex;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "roboto", sans-serif;
}

img {
  display: block;
}

::-webkit-scrollbar {
  width: 7px;
  height: 0px;
}

::-webkit-scrollbar-thumb {
  height: 20px;
  background-color: #404047;
  border-radius: 5px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

::-webkit-scrollbar-thumb:hover {
  border: 0;
}

::-webkit-scrollbar:hover {
  border: 0;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-button {
  height: 10px;
}

::-webkit-scrollbar-track:hover {
  background-color: #2929299d;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/style/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,+DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB","sourcesContent":["@font-face {\r\n  font-family: \"roboto\";\r\n  src: url(\"../fonts/Roboto-Regular.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n:root {\r\n  color-scheme: dark;\r\n}\r\n\r\n#root,\r\nhtml,\r\nbody,\r\n.nav-content {\r\n  height: 100%;\r\n}\r\n\r\n#root {\r\n  display: flex;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: \"roboto\", sans-serif;\r\n}\r\n\r\nimg {\r\n  display: block;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 7px;\r\n  height: 0px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  height: 20px;\r\n  background-color: #404047;\r\n  border-radius: 5px;\r\n  border: 2px solid transparent;\r\n  background-clip: padding-box;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  border: 0;\r\n}\r\n\r\n::-webkit-scrollbar:hover {\r\n  border: 0;\r\n  width: 10px;\r\n  height: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-button {\r\n  height: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-track:hover {\r\n  background-color: #2929299d;\r\n  border-radius: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
